import React, {useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavbarLink } from './NavbarLink';

const links = [
  {
    to: '/about-us',
    title: 'ABOUT US',
  },
  {
    to: '/vehicle-fleet',
    title: 'VEHICLE FLEET',
  },
  {
    to: '/corporate-private-athletic-groups',
    title: 'CORPORATE, PRIVATE, & ATHLETIC GROUPS',
  },
  {
    to: '/wedding',
    title: 'WEDDINGS',
  },
  {
    to: '/school-groups',
    title: 'SCHOOL GROUPS',
  },
  {
    to: '/custom-group-tours',
    title: 'CUSTOM GROUP TOURS',
  },
  {
    to: '/IMG',
    title: 'INTERNATIONAL MOTORCOACH GROUP',
  },
];

const Navbar = () => {
  const [open, setIsOpen] = useState(false);
  const location = useLocation();

  const shouldDisplayString = ((location.pathname !== '/request-a-quote') && (location.pathname !== '/charter/request-a-quote'));

  return (
    <nav className="bg-green-900 shadow-lg">
      <div className="mx-auto px-4 py-4">
        <div className="flex lg:justify-center justify-start">
          <div className="flex space-x-7">
            <div className="hidden lg:flex lg:flex-row justify-content-stretch justify-items-stretch">
              { Object.keys(links).map((link, ndx) => (
                <NavbarLink
                  key={ndx}
                  to={links[link].to}
                  title={links[link].title}
                />
              ))}
            </div>
          </div>
          <div className="lg:hidden flex items-center">
            <button 
              className="outline-none mobile-menu-button"
              onClick={ () => {
                setIsOpen(!open);
              }}
            >
            <svg className="w-6 h-6 text-white hover:text-slate-400 "
              x-show="!showMenu"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
              {/* Always display this string */}
              { shouldDisplayString && (<div className="text-right text-white px-2 py-1 bg-green-900 font-semibold">
              <a 
                href={`${process.env.PUBLIC_URL}/request-a-quote`} 
                className="text-end block text-sm px-4 py-6 text-white hover:bg-green-300 bg-green-500 font-semibold"
              >REQUEST A QUOTE</a>
              </div>)}
              {/* Always display this string */}
              { (<div className="text-right text-white px-2 py-1 bg-green-900 font-semibold">
              <a 
                href="tel:+16312874000"
                className="text-end block text-sm px-4 py-6 text-white hover:bg-green-300 bg-green-500 font-semibold"
              >CALL US</a>
              </div>)}
          </div>
        </div>
      </div>
      <div className={`${!open ? `hidden` : ``} mobile-menu`}>
        <ul className="">
          { Object.keys(links).map((link, ndx) => (
            <li
              key={ndx}
            >
              <a 
                href={`${process.env.PUBLIC_URL}${links[link].to}`} 
                className="block text-sm px-2 py-4 text-white hover:bg-green-500 bg-green-800 font-semibold"
              >{links[link].title}</a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;